<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('nfc.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <!--        <div class="type-item" @click="toList('TA600')">-->
            <!--            <div class="type-icon">-->
            <!--                <img class="type-img" src="@/assets/common/problem/TA600.png">-->
            <!--            </div>-->
            <!--            <div class="type-name">SYNTIME 5</div>-->
            <!--            <div class="type-model">{{ $t('problemType.model') }}: TA3000</div>-->
            <!--            <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">-->
            <!--        </div>-->
            <div class="type-item" @click="toList('TA700')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA700.png">
                </div>
                <div class="type-name">ASTROLINK S/G</div>
                <div class="type-model">{{ $t('problemType.model') }}: TA700S,TA700G,TA700B</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <div class="type-item" @click="toList('TA3000')">
                <div class="type-icon">
                    <img class="type-img" src="@/assets/common/problem/TA3000.png">
                </div>
                <div class="type-name">SYNTIME 5</div>
                <div class="type-model">{{ $t('problemType.model') }}: TA3000</div>
                <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">
            </div>
            <!--        <div class="type-item" @click="toList('TA700')">-->
            <!--            <div class="type-icon">-->
            <!--                <img class="type-img" src="@/assets/common/problem/TA700.png">-->
            <!--            </div>-->
            <!--            <div class="type-name">ASTROLINK S</div>-->
            <!--            <div class="type-model">{{ $t('problemType.model') }}: TA700 S</div>-->
            <!--            <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">-->
            <!--        </div>-->
            <!--        <div class="type-item" @click="toList('TA700')">-->
            <!--            <div class="type-icon">-->
            <!--                <img class="type-img" src="@/assets/common/problem/TA700.png">-->
            <!--            </div>-->
            <!--            <div class="type-name">ASTROLINK B</div>-->
            <!--            <div class="type-model">{{ $t('problemType.model') }}: TA700 B</div>-->
            <!--            <img class="to-desc-img" src="@/assets/share/friendDesc/toAll.png">-->
            <!--        </div>-->
        </div>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'problemType',
    data() {
        return {
            maxKbScript: null,
            theme: 'light'
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme;
        }
        // this.loadMaxKbScript();
    },
    beforeDestroy() {
        // this.removeMaxKbScript();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        toList(type) {
            this.$router.push({
                name: 'prodInstructions',
                query: {
                    type: type,
                    lang: this.$i18n.locale,
                    theme: this.theme,
                    from: 'web'
                }
            })
        },
        loadMaxKbScript() {
            console.log('loadMaxKbScript');
            let maxKb = document.getElementById('maxkb');
            if (maxKb) {
                maxKb.style.display = 'block';
            }
            const script = document.createElement('script');
            script.async = true;
            script.defer = true;
            script.src = 'https://service.beidouwatch.com/api/application/embed?protocol=https&host=service.beidouwatch.com&token=3a8b66e71698bb52';
            document.body.appendChild(script);
            this.maxKbScript = script;
        },
        removeMaxKbScript() {
            console.log('removeMaxKbScript');
            if (this.maxKbScript && this.maxKbScript.parentNode) {
                this.maxKbScript.parentNode.removeChild(this.maxKbScript);
            }
            let maxKb = document.getElementById('maxkb');
            if (maxKb) {
                maxKb.style.display = 'none';
            }
        }
    }
}
</script>

<style scoped>

.type-item {
    width: 345px;
    height: 70px;
    background: var(--bg-color-2);
    opacity: 1;
    border-radius: 6px;
    margin: 20px auto;
    position: relative;
}

.type-img {
    width: 50px;
    position: absolute;
    top: 10px;
    left: 15px;
}

.type-name {
    position: absolute;
    left: 70px;
    top: 15px;
    font-size: 15px;
    color: var(--text-color-1);
}

.type-model {
    position: absolute;
    left: 70px;
    top: 35px;
    font-size: 12px;
    color: var(--text-color-1);
}

.to-desc-img {
    position: absolute;
    right: 15px;
    top: 28px;
    width: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/problemType.vue